export type CheckAttemptType = 'CHECKIN' | 'CHECKOUT'
export type CheckAttemptOutcome = 'ACCEPTED' | 'REJECTED'
export type CheckAttemptCheckMethod = 'GEOLOCATION' | 'BIOMETRIC' | 'MANUAL'

export type CheckAttemptReason =
  | 'OUT_OF_RANGE'
  | 'UNIT_WITHOUT_COORDINATES'
  | 'INVALID_RADIUS_CONFIG'
  | 'TOO_EARLY'
  | 'TOO_LATE'
  | 'ALREADY_CHECKED_IN'
  | 'ALREADY_CHECKED_OUT'
  | 'NO_CHECKIN'
  | 'BIOMETRY_SELFIE_REQUIRED'
  | 'BIOMETRY_NO_MATCH'
  | 'BIOMETRY_REJECTED'
  | 'BIOMETRY_NOT_REGISTERED'
  | 'BIOMETRY_PENDING_APPROVAL'
  | 'BIOMETRY_PHOTO_UNAVAILABLE'
  | 'BIOMETRY_SERVICE_ERROR'
  | 'STATION_NOT_FOUND'
  | 'TIMEOUT'
  | 'OTHER'
  | 'LOCATION_PERMISSION_DENIED'
  | 'LOCATION_UNAVAILABLE'

export const CHECK_ATTEMPT_REASON_LABELS: Record<CheckAttemptReason, string> = {
  OUT_OF_RANGE: 'Fora do raio',
  UNIT_WITHOUT_COORDINATES: 'Unidade sem coordenadas',
  INVALID_RADIUS_CONFIG: 'Raio inválido',
  TOO_EARLY: 'Cedo demais',
  TOO_LATE: 'Horário já passou',
  ALREADY_CHECKED_IN: 'Check-in já feito',
  ALREADY_CHECKED_OUT: 'Check-out já feito',
  NO_CHECKIN: 'Sem check-in',
  BIOMETRY_SELFIE_REQUIRED: 'Selfie obrigatória',
  BIOMETRY_NO_MATCH: 'Biometria não confere',
  BIOMETRY_REJECTED: 'Biometria rejeitada',
  BIOMETRY_NOT_REGISTERED: 'Biometria não cadastrada',
  BIOMETRY_PENDING_APPROVAL: 'Biometria pendente',
  BIOMETRY_PHOTO_UNAVAILABLE: 'Foto indisponível',
  BIOMETRY_SERVICE_ERROR: 'Erro no serviço de biometria',
  STATION_NOT_FOUND: 'Plantão não encontrado',
  TIMEOUT: 'Tempo esgotado',
  OTHER: 'Outro',
  LOCATION_PERMISSION_DENIED: 'Permissão de localização negada',
  LOCATION_UNAVAILABLE: 'Localização indisponível'
}

export const CHECK_ATTEMPT_TYPE_LABELS: Record<CheckAttemptType, string> = {
  CHECKIN: 'Check-in',
  CHECKOUT: 'Check-out'
}

export interface CheckAttemptItem {
  id: number
  createdAt: string
  type: CheckAttemptType
  outcome: CheckAttemptOutcome
  reason: CheckAttemptReason | null
  message: string | null
  checkMethod: CheckAttemptCheckMethod | null
  clientDate: string | null
  userAgent: string | null
  distanceM: number | null
  reachRadiusM: number | null
  checkLatitude: number | null
  checkLongitude: number | null
  unitLatitude: number | null
  unitLongitude: number | null
  healthUnitAddressId: number | null
  unitPinDiffersFromCurrent: boolean
  doctor: { id: number; name: string } | null
  station: { id: number; date: string; startHour: string; endHour: string } | null
  doctorCheckId: number | null
}

export interface CheckAttemptsListResponse {
  data: CheckAttemptItem[]
  total: number
  page: number
  limit: number
  summary: { total: number; rejected: number; maxRejectedDistanceM: number | null }
  healthUnit: {
    id: number
    latitude: number | null
    longitude: number | null
    reachRadiusM: number | null
    addressId: number | null
  } | null
  doctors: { id: number; name: string }[]
}
